import React from "react";
import "./ProjectDetailBlock.css";

function ProjectDetailBlock({ title, location, capacity, timeline, scope, image, locationIcon, capacityIcon, timeIcon, epcIcon, story }) {
  return (
    <section className="block block6">

      <h2 className="block6-title">{title || ''}</h2>

      <div className="block6-info-strip">
        <div className="info-item">
          {locationIcon && <img src={locationIcon} alt="Location" />}
          <span>{location || ''}</span>
        </div>
        <div className="info-item">
          {capacityIcon && <img src={capacityIcon} alt="Capacity" />}
          <span>{capacity || ''}</span>
        </div>
        <div className="info-item">
          {timeIcon && <img src={timeIcon} alt="Execution Period" />}
          <span>{timeline || ''}</span>
        </div>
        <div className="info-item">
          {epcIcon && <img src={epcIcon} alt="EPC" />}
          <span>{scope || ''}</span>
        </div>
      </div>

      <div className="block6-image">
        {image && <img src={image} alt="Project" />}
      </div>

      <div className="block6-story">
        {(story || '').split('\n\n').map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>

    </section>
  );
}

export default ProjectDetailBlock;
